<template>

	<v-card class="mt-4" :loading="listando">

		<v-sheet
			class="v-sheet--offset mx-auto"
			color="cyan"
			elevation="12"
			max-width="calc(100% - 32px)"
			style="position: relative; top: -24px;"
		>
			<v-sparkline
				:labels="datos.etiquetas"
				:value="datos.valores"
				color="white"
				line-width="2"
				padding="16"
				:smooth="4"
			></v-sparkline>
		</v-sheet>

		<v-card-text
			v-if="selector"
			class="pt-0"
		>
			<selector-de-fecha
				v-model="fecha"
				:día="modoDía"
				hide-details
			></selector-de-fecha>
		</v-card-text>

		<v-card-text v-if="datos.productosÚnicos.length" class="py-0">
			<div class="title font-weight-light mb-2">{{ textoHayVentas }}</div>
		</v-card-text>

		<v-simple-table v-if="datos.productosÚnicos.length" dense>
			<template v-slot:default>
				<thead>
					<tr>
						<th>Producto</th>
						<th class="text-right">Cantidad vendido</th>
						<th class="text-right">Precio total vendido</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="p in datos.productosÚnicos" :key="p.identificador">
						<td>{{ p.descripción }}</td>
						<td class="text-right">{{ número(p.cantidad) }}</td>
						<td class="text-right">{{ moneda(p.precioTotal) }}</td>
					</tr>
				</tbody>
			</template>
		</v-simple-table>

		<v-card-text v-if="datos.montoTotal === 0 && !listando">
			<div class="subheading font-weight-light grey--text">{{ textoNoHayVentas }}</div>
		</v-card-text>

		<v-card-text v-if="datos.montoTotal > 0 && !listando">
			<v-divider></v-divider>
			<div class="title font-weight-regular mt-3">{{ textoTotalVendido }}: {{ moneda(datos.montoTotal) }}</div>
		</v-card-text>

	</v-card>

</template>

<script>
import { número, moneda, fecha } from '@/../../cliente_comun/utilidades'
import { facturasDeVenta } from '@/../../cliente_comun/fuentes'
import SelectorDeFecha from '../components/utilidades/selectorDeFecha.vue'

export default {
	name: 'resumen-ventas-periodo',
  data: () => ({
		fuente: facturasDeVenta,
		listando: false,
		listado: [],
		fecha: '',
		datos: {
			etiquetas: [],
			valores: [],
			montoTotal: 0,
			productosÚnicos: []
		},
		selector: false,
	}),
	props: [
		'hoy',
		'este-mes',
		'predeterminado',
		'modo',
	],
	components: {
		SelectorDeFecha
	},
	computed: {
		textoHayVentas: function() {
			if (!this.fecha) {
				return ''
			}

			if (this.exclusivoHoy) {
				return 'Ventas de hoy'
			}

			if (this.exclusivoEsteMes) {
				return 'Ventas de este mes'
			}

			let l = this.modoDía ? 'l' : ''

			return `Ventas de${l} ${fecha.legible(this.fecha)}`
		},
		textoNoHayVentas: function() {
			if (!this.fecha) {
				return ''
			}

			if (this.exclusivoHoy) {
				return 'No ha habido ventas hoy'
			}

			if (this.exclusivoEsteMes) {
				return 'No ha habido ventas este mes'
			}

			let elEn = this.modoDía ? 'el' : 'en'

			return `No hubo ventas ${elEn} ${fecha.legible(this.fecha)}`
		},
		textoTotalVendido: function() {
			if (!this.fecha) {
				return ''
			}

			if (this.exclusivoHoy) {
				return 'Total vendido hoy'
			}

			if (this.exclusivoEsteMes) {
				return 'Total vendido este mes'
			}

			let elEn = this.modoDía ? 'el' : 'en'

			return `Total vendido ${elEn} ${fecha.legible(this.fecha)}`
		},
		exclusivoHoy: function() {
			return this.hoy || (typeof this.hoy === 'string' && this.hoy === '')
		},
		exclusivoEsteMes: function() {
			return this.esteMes || (typeof this.esteMes === 'string' && this.esteMes === '')
		},
		modoDía: function() {
			return this.modo === 'día' || this.exclusivoHoy
		}
	},
	watch: {
		fecha: {
			handler: function(f) {
				if (!f || f.length < 7 || (this.modoDía && f.length !== 10)) {
					this.limpiar()
					return
				}

				let pdzs = f.split('-')
				let aaaa = Number(pdzs[0])
				let mmDesde = Number(pdzs[1]) - 1
				let mmHasta = null
				let ddDesde = null
				let ddHasta = null
				if (this.modoDía) {
					mmHasta = mmDesde
					ddDesde = Number(pdzs[2])
					ddHasta = ddDesde + 1
				} else {
					mmHasta = mmDesde + 1
					ddDesde = 1
					ddHasta = 1
				}

				let desde = new Date(aaaa, mmDesde, ddDesde)
				let hasta = new Date(aaaa, mmHasta, ddHasta)

				this.obtener(desde, hasta)
			},
			deep: true
		},
		modo: {
			handler: function(vn, va) {
				this.limpiar()
				if (this.modoDía) {
					this.datos.etiquetas = ['12am', '2am', '4am', '6am', '8am', '10am', '12pm', '2pm', '4pm', '6pm', '8pm', '10pm']
				} else {
					this.datos.etiquetas = [ '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31' ]
				}
			},
			deep: true
		}
	},
	mounted: function() {
		if (this.exclusivoHoy) {
			this.fecha = this.fechaHoy()
		} else if (this.exclusivoEsteMes) {
			this.fecha = this.fechaEsteMes()
		} else {
			this.selector = true
			if (this.predeterminado === 'hoy') {
				this.$nextTick(() => {
					this.fecha = this.fechaHoy()
				})
			} else if (this.predeterminado === 'ayer') {
				this.$nextTick(() => {
					this.fecha = this.fechaAyer()
				})
			} else if (this.predeterminado === 'este-mes') {
				this.$nextTick(() => {
					this.fecha = this.fechaEsteMes()
				})
			} else if (this.predeterminado === 'el-mes-pasado') {
				this.$nextTick(() => {
					this.fecha = this.fechaElMesPasado()
				})
			}
		}
	},
	methods: {
		número,
		moneda,
		agrupar: function(listadoFacturasDeVenta) {
			if (this.modoDía) {
				this.agruparPorDía(listadoFacturasDeVenta)
			} else {
				this.agruparPorMes(listadoFacturasDeVenta)
			}
		},
		agruparPorDía: function(listadoFacturasDeVenta) {
			this.limpiar()

			let F = listadoFacturasDeVenta.find(f => !f.anulada)
			if (!F) {
				return
			}

			let fechaBase = new Date(F.creación.fecha.seconds * 1000)
			let fBase = new Date(fechaBase.getFullYear(), fechaBase.getMonth(), fechaBase.getDate())
			let base = Math.floor(fBase.getTime() / 1000)

			let valores = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
			let montoTotal = 0
			let productosÚnicos = []
			for (let f of listadoFacturasDeVenta) {
				if (f.anulada) {
					continue
				}

				for (let i = 0; i < 12; i++) {
					if (f.creación.fecha.seconds >= base + ((i * 2) * 60 * 60) && f.creación.fecha.seconds < base + (((i * 2) + 2) * 60 * 60)) {
						valores[i] = valores[i] + Number(f.total)
					}
				}

				montoTotal = montoTotal + Number(f.total)
				this.agruparProductosÚnicos(productosÚnicos, f)
			}

			this.poblar(valores, montoTotal, productosÚnicos)
		},
		agruparPorMes: function(listadoFacturasDeVenta) {
			this.limpiar()

			let valores = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
			let montoTotal = 0
			let productosÚnicos = []
			for (let f of listadoFacturasDeVenta) {
				if (f.anulada) {
					continue
				}

				let día = (new Date(f.creación.fecha.seconds * 1000)).getDate() - 1
				valores[día] = valores[día] + Number(f.total)
				montoTotal = montoTotal + Number(f.total)
				this.agruparProductosÚnicos(productosÚnicos, f)
			}

			this.poblar(valores, montoTotal, productosÚnicos)
		},
		agruparProductosÚnicos: function(productosÚnicos, factura) {
			for (let p of factura.productos) {
				let ind = productosÚnicos.findIndex( ele => ele.identificador === p.identificador)
				if (ind === -1) {
					productosÚnicos.push(JSON.parse(JSON.stringify(p)))
				} else {
					productosÚnicos[ind].cantidad = Number(productosÚnicos[ind].cantidad) + Number(p.cantidad)
					productosÚnicos[ind].precioTotal = Number(productosÚnicos[ind].precioTotal) + Number(p.precioTotal)
				}
			}
		},
		obtener: function(desde, hasta) {
			this.listando = true
			this.fuente.listar(desde, hasta).then(listado => {
				this.listando = false
				this.agrupar(listado)
			}).catch(() => {
				this.listando = false
			})
		},
		poblar: function(valores, montoTotal, productosÚnicos) {
			this.datos.valores = valores
			this.datos.montoTotal = montoTotal
			this.datos.productosÚnicos = productosÚnicos

			this.$emit('input', {
				fecha: this.fecha,
				montoTotal,
				productosÚnicos
			})
		},
		limpiar: function() {
			this.datos.montoTotal = 0
			this.datos.productosÚnicos = []

			if (this.modoDía) {
				this.datos.valores = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
			} else {
				this.datos.valores = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
			}

			this.$emit('input', {
				fecha: this.fecha,
				montoTotal: 0,
				productosÚnicos: []
			})
		},
		fechaHoy: function() {
			return this.formatearAAAAMMDD()
		},
		fechaAyer: function() {
			let hoy = new Date()
			let ayer = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate() - 1)
			return this.formatearAAAAMMDD(ayer)
		},
		fechaEsteMes: function() {
			return this.formatearAAAAMM()
		},
		fechaElMesPasado: function() {
			let hoy = new Date()
			let elMesPasado = new Date(hoy.getFullYear(), hoy.getMonth() - 1, hoy.getDate())
			return this.formatearAAAAMM(elMesPasado)
		},
		formatearAAAAMM: function(f) {
			let d = this.componentesFecha(f)
			return `${d.aaaa}-${d.mm}`
		},
		formatearAAAAMMDD: function(f) {
			let d = this.componentesFecha(f)
			return `${d.aaaa}-${d.mm}-${d.dd}`
		},
		componentesFecha: function(f) {
			if (!f) {
				f = new Date()
			}

			let aaaa = f.getFullYear()
			let mm = f.getMonth() + 1
			let dd = f.getDate()
			mm = mm < 10 ? `0${mm}` : mm
			dd = dd < 10 ? `0${dd}` : dd

			let datos = {
				aaaa: aaaa.toString(),
				mm: mm.toString(),
				dd: dd.toString()
			}

			return datos
		}
	}
}
</script>